import numberToWord from 'utils/format/numberToWord'
import { capitalize } from '@hc-frontend/utils'

export interface ExtendedMessage {
  addMessage: string
  removeMessage: string
}

export interface ExtendedMessageParams {
  period: number
  extendedDuration?: number
  maxPolicies: number
  policies?: number
}

function getExtendedMessage({
  period,
  extendedDuration = period,
  maxPolicies,
  policies
}: ExtendedMessageParams): ExtendedMessage {
  let addMessage = ''

  switch (period) {
    case 90:
      addMessage = `Add ${
        maxPolicies === 4 ? 'three more coverages' : 'another coverage'
      } of 90 days`
      break
    case 364:
      addMessage =
        extendedDuration === period
          ? `Get coverage for ${maxPolicies} years.`
          : `Add another coverage of ${extendedDuration} days`
      break

    default:
      addMessage = `Add another coverage of ${period} days`
      break
  }

  const removeMessage =
    extendedDuration === period
      ? `${capitalize(numberToWord(policies))} coverage periods of ${period} days`
      : `1 coverage period of ${period} days + ${extendedDuration} days`

  return { addMessage, removeMessage }
}

export default getExtendedMessage
